// import React from 'react'
// import ClipBord from '../../../../assets/images/relatedtopic.png'
// import Cancel from '../../../../assets/images/ordercencel.png'
// import '../sellarShop/popup.css'
// const RelatedTopics = () => {
//   return (
    
//     <div className='add-css-styling-cancel-div'>
//     <img src={Cancel} style={{width:'1.4em',objectFit:'contain'}}/>
//     <h5 className='h5-heaidng-invouice'>Order Cancellation</h5>
//     </div>
  
//   )
// }

// export default RelatedTopics
import React from 'react'

const RelatedTopics = ({ title, icon }) => {
  return (
    <div className='add-css-styling-cancel-div' style={{ cursor: 'pointer', marginBottom: '10px' }}>
        <img src={icon} style={{ width: '1.4em', objectFit: 'contain' }} alt={title} />
        {/* Paragraph text ke liye Manrope font */}
        <h5 className='h5-heaidng-invouice' style={{ fontFamily: 'Manrope', fontSize: '15px' }}>
            {title}
        </h5>
    </div>
  )
}

export default RelatedTopics